import { RenderProps } from '@nackle/translation-editor/src/TranslationController';
import { Button, Card, Menu, Popover } from '@nackle/paper';
import { Pencil, Link, Trash } from '@nackle/icons';
import { Menu3 } from '@nackle/icons/dist/react-es/ultimate';
import { TranslationControllerWrapper } from 'app/components/routes/updatecmx/TranslationControllerWrapper';
import React, { Component } from 'react';
import { ROM_PATH_UPDATE, ROMS_PATH } from 'routes/paths';
import { formatCmxCabinetNameKey } from 'routes/updatecmx/cmxKeyNames';
import { CardHeader } from 'shared/card-header';
import { confirm } from 'shared/dialogs';
import { HasPermission } from 'shared/HasPermission';
import { Cabinet } from 'shared/interfaces';

interface Props  {
    cabinet: Cabinet;
    onDelete: (id: string) => void;
    onEdit: (cabinetId: string) => void;
}

export class ArcadeCabinetListEntry extends Component<Props> {
    public render() {
        const {
            cabinet,
        } = this.props;

        const editButton = (
            <HasPermission app="arcade-api" permission="edit-cabinet">
                {(hasPermission: boolean) =>
                    <Menu.Item
                        data-cabinet-id={cabinet.cabinetId}
                        icon={<Pencil/>}
                        onClick={this.handleEdit}
                        title={hasPermission ? 'Edit Cabinet' : 'View Cabinet'}
                    >
                        {hasPermission ? 'Edit Cabinet' : 'View Cabinet'}
                    </Menu.Item>
                }
            </HasPermission>
        );

        const romLink = (
            <Menu.Item
                icon={<Link/>}
                title="View ROM"
            >
                <a href={'../..' + ROMS_PATH + ROM_PATH_UPDATE.replace(':romId', cabinet.romId)}>
                </a>
                View ROM
            </Menu.Item>
        );

        const deleteButton = (
            <HasPermission app="arcade-api" permission="delete-cabinet">
                {(hasPermission: boolean) =>
                <Menu>
                    <Menu.Item
                        data-open-modal-button-id={cabinet.cabinetId}
                        disabled={!hasPermission}
                        icon={<Trash/>}
                        danger={true}
                        onClick={this.handleDelete}
                        id={`open-modal-btn-${cabinet.cabinetId}`}
                        title="Delete"
                    >
                        Delete
                    </Menu.Item>
                </Menu>
                }
            </HasPermission>
        );

        const cardMenu = (
            <Popover 
            trigger="click"
            autoAdjustOverflow
            destroyTooltipOnHide
                content={
                    <Menu>
                        {editButton}
                        {romLink}
                        {deleteButton}
                    </Menu>
                }
            >
                <Button
                    icon={<Menu3/>}
                    id={`menu-btn-${cabinet.cabinetId}`}
                    size="small"
                />
            </Popover>
        );

        const title = (
            <TranslationControllerWrapper keyName={formatCmxCabinetNameKey(cabinet.cabinetId)}>
                {(renderProps: RenderProps) =>
                    <div className={renderProps.isLoaded ? '' : 'skeleton'}>
                        { renderProps.isLoaded && (renderProps.defaultCustomTranslation || renderProps.defaultGoldTranslation) || cabinet.name }
                    </div>
                }
            </TranslationControllerWrapper>
        );

        return (
            <Card
                id={`arcadeCabinetCard-${cabinet.cabinetId}`}
                key={cabinet.cabinetId}
                data-cabinet-id={cabinet.cabinetId}
            >
                <CardHeader
                    className="arcade-game-name"
                    right={cardMenu}
                    title={title}
                />

                {cabinet.image ? <img className="arcade-cabinet-image-preview" src={cabinet.image} /> : <div>(no image)</div>}
            </Card>
        );
    }

    private handleEdit = () => this.props.onEdit(this.props.cabinet.cabinetId);

    private handleDelete = async () => {
        const { cabinet } = this.props;

        confirm({
            message: <p>Are you sure you want to delete the arcade game cabinet <strong>{cabinet.name}</strong>?</p>,
            modalId: cabinet.cabinetId,
            primaryButtonText: 'Delete',
            onConfirm: () => this.props.onDelete(cabinet.cabinetId),
        });
    };
}
